export const MASTER_DATA_ENDPOINTS = {
  BOUNDARIES: "/reporting-boundary",
  LIST: "/esg-master-data",
  CREATE: "/esg-master-data/save-by-disclosures",
  CLONE_BY_YEAR: "/esg-master-data/clone-by-year",
  UPDATE: (disclosureId) => `/esg-master-data/${disclosureId}`,
  DELETE: (disclosureId) => `/esg-master-data/${disclosureId}`,
  DELETE_MULTIPLE: "/esg-master-data/delete-multiple",
};
